<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30ZM15 27.2728C21.778 27.2728 27.2727 21.7781 27.2727 15.0001C27.2727 8.22201 21.778 2.72732 15 2.72732C8.22191 2.72732 2.72723 8.22201 2.72723 15.0001C2.72723 21.7781 8.22191 27.2728 15 27.2728ZM8.18194 13.6365V16.3637H21.8183V13.6365H8.18194ZM8.18194 20.4546V17.7273H21.8183V20.4546H8.18194ZM8.18194 9.54563V12.2729H21.8183V9.54563H8.18194Z"
        fill="#10233E"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
